import gsap from 'gsap';
import Swiper from 'swiper';
import SwiperCore, { Navigation, Pagination, Autoplay } from 'swiper/core';

import 'swiper/swiper.min.css';
import 'swiper/swiper-bundle.css';


export default class Story {

  constructor() {
    this._init();
  }


  _init() {
    this.$swipeSlide = document.querySelectorAll('.story__swiper .story__swiper__item');
    SwiperCore.use([Navigation, Pagination, Autoplay]);
    this._setSwiper();
  }

  _setSwiper() {
    const opts = {
      loop: (this.$swipeSlide.length > 1) ? true : false,
      slidesPerView: 'auto',
      autoplay: {
        delay: 7000
      },
      pagination: {
        el: ".story__swiper__pagination",
        clickable: true,
      },
      navigation: {
        nextEl: ".story__swiper__next",
        prevEl: ".story__swiper__prev"
      },
      spaceBetween: 0,
      speed: 700,
      observer: true,
      observeParents: true
    };

    this.swiper = new Swiper('.story__swiper__container', opts);

  }
}
